"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadScript(src) {
	return new _promise2.default(function (resolve, reject) {
		var s = void 0;
		s = document.createElement("script");
		s.src = src;
		s.onload = resolve;
		s.onerror = reject;
		document.body.appendChild(s);
	});
}

exports.default = function (props) {
	var updatedComps = (0, _extends3.default)({}, props.components);
	delete updatedComps.CategorySnippet;

	if ((0, _keys2.default)(updatedComps).length === 0) {
		console.warn("No components were added to the PowerReviewConfig, please make sure you are spelling your component correctly or that it exists, ignore this warning if you are meaning to only pass in categorySnippets");
	}
	var mainComp = {
		api_key: props.apiKey,
		locale: props.locale || "en_US",
		merchant_group_id: props.merchantGroupId,
		merchant_id: props.merchantId,
		page_id: props.pageId,
		review_wrapper_url: props.wrapperUrl || "/write-review?page_id=" + props.pageId,
		components: updatedComps,
		on_render: function on_render(config, data) {
			if (props.init) {
				props.init(config, data);
			}
		},
		on_submit: function on_submit(config, data) {
			if (props.submitted) {
				props.submitted(config, data);
			}
		}
	};
	if (props.product) {
		mainComp.product = props.product;
	}
	if (props.config) {
		(0, _keys2.default)(props.config).forEach(function (key) {
			mainComp[key] = props.config[key];
		});
	}
	var content = [mainComp];

	if (props.categorySnippets) {
		props.categorySnippets.snippets.forEach(function (snippet) {
			content.push({
				locale: "en_US",
				merchant_group_id: snippet.merchantGroupId || props.merchantGroupId,
				merchant_id: snippet.merchantId || props.merchantId,
				page_id: snippet.id || snippet,
				api_key: snippet.apiKey || props.apiKey,
				components: {
					CategorySnippet: snippet.slug ? snippet.slug + "-" + (snippet.id || snippet) : props.categorySnippets.id + "-" + (snippet.id || snippet)
				}
			});
		});
	}

	if (props.log) {
		console.log("content: ", content);
		console.log("JSON Stringify content: ", (0, _stringify2.default)(content));
	}
	// content = content.length > 1 ? content : content[0]

	return new _promise2.default(function () {
		var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
			return _regenerator2.default.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!(!window.POWERREVIEWS || !window.POWERREVIEWS.display)) {
								_context.next = 7;
								break;
							}

							console.log("Loading Power Reviews Script");
							_context.next = 4;
							return loadScript("//ui.powerreviews.com/stable/4.0/ui.js").catch(function (err) {
								reject("Something went wrong while loading the script: " + err);
							});

						case 4:
							window.POWERREVIEWS.display.render(content);
							if ((0, _keys2.default)(content[0].components).length === 0) {
								content[0].on_render(props.config || {}, content);
							}
							resolve(content);

						case 7:
							window.POWERREVIEWS.display.render(content);
							if ((0, _keys2.default)(content[0].components).length === 0) {
								content[0].on_render(props.config || {}, content);
							}
							resolve(content);

						case 10:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}());
};